export default __webpack_public_path__ + "static/icon-4-3-f20f51f165fea3b0ac88fcf3c068f8d0.png";